import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class NewOrderService {
  public change = new BehaviorSubject(false);
  constructor() { }

}
